import React from 'react'
import './ChannelRow.css';
import { Avatar } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';;

function ChannelRow({ image, channel, verified, subs, noOfVideos, description }) {
    return (
        <div className="channelRow">
            <div className="channelRow__logopostion">
                <Avatar className="channelRow__logo" alt={channel} src={image} />
            </div>
            <div className="channelRow__text">
                <div className="channelRow__title">
                    <h4>{channel}</h4> 
                    {verified && <CheckCircleIcon style={{"marginLeft": "10px", "color": "rgb(170,170,170)", "fontSize": "20px"}} />}
                </div>
                <p className="alignment bottom">
                    {subs}  subscribers <span role="img" style={{"fontSize": "5px", "margin": "0px 5px", "opacity": "0.5"}} aria-labelledby="accessability"> ⚪ </span> {noOfVideos} videos
                </p>
                <p>{description}</p>
                <div className="alignsub">
                    <div className="channelRow__subbtn2">
                        <button>SUBSCRIBE</button>
                    </div>
                </div>
            </div>
            <div className="channelRow__subbtn">
                <button>SUBSCRIBE</button>
            </div>
        </div>
    )
}

export default ChannelRow
